import React, { useState } from 'react';
import { Col, Container, Image, Modal, Row } from 'react-bootstrap';
import Slider from 'react-slick';
import { FaChevronLeft, FaChevronRight, FaTimes } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const NextArrow = (props) => {
    const { className, style, onClick } = props;
    return (
        <FaChevronRight
            className={className}
            style={{ ...style, display: 'block', color: '#ffffff', fontSize: '24px' }}
            onClick={onClick}
        />
    );
};

const PrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
        <FaChevronLeft
            className={className}
            style={{ ...style, display: 'block', color: '#ffffff', fontSize: '24px' }}
            onClick={onClick}
        />
    );
};

const Rzr = ({ allPrizesEnded }) => {
    const [showModal, setShowModal] = useState(false);
    const [currentImage, setCurrentImage] = useState('');

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 3000,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />
    };

    const images = [
        "https://d2bxnt3cp18qf5.cloudfront.net/RZR1.webp",
        "https://d2bxnt3cp18qf5.cloudfront.net/RZR2.webp",
        "https://d2bxnt3cp18qf5.cloudfront.net/RZR3.webp",
        "https://d2bxnt3cp18qf5.cloudfront.net/RZR4.webp",
        "https://d2bxnt3cp18qf5.cloudfront.net/RZR5.webp",
    ];

    const handleImageClick = (image) => {
        setCurrentImage(image);
        setShowModal(true);
    };

    const handleClose = () => setShowModal(false);

    return (
        <Container id='rzr'>

            <div className="text-center rzr-section py-4 ">
                <h2 style={{ color: "#f96800" }} className=" headingtext mt-2">

                    {!allPrizesEnded ? "UNLEASH A FORCE OF NATURE" : "THE GIVEAWAY HAS ENDED"}
                </h2>
            </div>

            <Col xs={10} lg={7} className="mx-auto mb-4">
                <div className="carousel-container">
                    <Slider {...settings}>
                        {images.map((image, index) => (
                            <div key={index} onClick={() => handleImageClick(image)}>
                                <Image src={image} alt={`Slide ${index + 1}`} style={{ width: '100%', cursor: 'pointer' }} />
                            </div>
                        ))}
                    </Slider>
                </div>
            </Col>

            {!allPrizesEnded &&
                <>
                    <div className="text-center rzr-under-section pt-5">
                        <h1 className='text-white regulartext chance'>ENTER FOR A CHANCE TO WIN THIS REAL:</h1>
                        <Link target='_blank' style={{ color: "#f96800" }} to={"https://www.polaris.com/en-ca/polaris-call-of-duty/"}>
                            <h1 style={{ color: "#f96800" }} className=' regulartext polaris-big'>POLARIS RZR PRO R 4</h1>
                        </Link>
                        <h1 className=' regulartext text-white'>BLACK OPS 6 SPECIAL EDITION</h1>
                        <p className='text-white paragraphtext mt-2 mb-5'>VALUE $47,000 USD</p>
                    </div>


                </>
            }








            {/* <Modal show={showModal} onHide={handleClose} centered size={"xl"} className=' bg-transparent'>
                <Modal.Header className='justify-content-end bg-transparent border-0' style={{ background: "transparent" }}>
                    <FaTimes onClick={handleClose} style={{ cursor: 'pointer', color: '#f96800', fontSize: '24px' }} />
                </Modal.Header>
                <Modal.Body className='bg-transparent p-0'>
                    <Image src={currentImage} alt="Enlarged" style={{ width: '100%' }} />
                </Modal.Body>
            </Modal> */}

            <Modal show={showModal} size='xl' onHide={handleClose} centered>
                <Modal.Header className='justify-content-end bg-transparent border-0 shadow-0' style={{ background: "transparent" }}>
                    <FaTimes onClick={handleClose} style={{ cursor: 'pointer', color: '#f96800', fontSize: '24px' }} />
                </Modal.Header>
                <Modal.Body className=" bg-black rounded">
                    <Image src={currentImage} alt={`Prize `} width="100%" />

                    <Row className='justify-content-center'>
                        {/* <Col xs={6} lg={4} >
                            <div className="mt-3 thumbnail-popup text-center">
                                <h4 className='regulartext '>
                                    HEADLINE
                                </h4>
                                <p className='paragraphtext  mt-3 text-white' >SAMPLE COPY TEXT</p>
                            </div>
                        </Col> */}
                    </Row>
                </Modal.Body>
            </Modal>
        </Container>
    );
};

export default Rzr;
